import { createRouter, createWebHistory } from 'vue-router';
import routes from '@/router/routes.js';
import { beforeEachRouteNavigationGuard } from '@/router/navigationGuards.js';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior (_to, _from, _savedPosition) {
    return { top: 0 };
  },
});

router.beforeEach(beforeEachRouteNavigationGuard);

export default router;
